var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "input taggle_textarea",
    attrs: { id: "taggle-editor" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }